import { http, host } from "@/common/index";
import https from "https";
import Vue from "vue";

Vue.config.productionTip = false;
Vue.prototype.$http = http;

http.defaults.timeout = 1000000;
http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const storeId = localStorage.getItem("store_id");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers.storeid = storeId;
    }

    const httpsAgent = new https.Agent({
      rejectUnauthorized: false,
    });
    config.httpsAgent = httpsAgent;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default {
  post(_, { data, url }) {
    return new Promise((resolve, reject) =>
      http
        .post(`${host}${url}`, data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        })
    );
  },
  getData(_, { data, url }) {
    return new Promise((resolve, reject) =>
      http
        .get(`${host}${url}`, data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        })
    );
  },
  get(_, url) {
    return new Promise((resolve, reject) =>
      http
        .get(`${host}${url}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err))
    );
  },
  put(_, { data, url }) {
    return new Promise((resolve, reject) =>
      http
        .put(`${host}${url}`, data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        })
    );
  },
  remove(_, url) {
    return new Promise((resolve, reject) =>
      http
        .delete(`${host}${url}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        })
    );
  },
};
